/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListNotificationsV1NotificationsGetParams,
  NotificationListResponse,
  NotificationResponse,
  NotificationStatusUpdateRequest
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * List the authenticated user's notifications with optional filters

Query Parameters:
- status: Filter by status (default: unread if not specified). Can specify multiple values.
- type: Filter by type. Can specify multiple values.
- priority: Filter by priority. Can specify multiple values.
 * @summary List Notifications
 */
export const listNotificationsV1NotificationsGet = (
    params?: ListNotificationsV1NotificationsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<NotificationListResponse>(
      {url: `/v1/notifications`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListNotificationsV1NotificationsGetQueryKey = (params?: ListNotificationsV1NotificationsGetParams,) => {
    return [`/v1/notifications`, ...(params ? [params]: [])] as const;
    }

    
export const getListNotificationsV1NotificationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsV1NotificationsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>> = ({ signal }) => listNotificationsV1NotificationsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListNotificationsV1NotificationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>>
export type ListNotificationsV1NotificationsGetQueryError = HTTPValidationError


export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListNotificationsV1NotificationsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Notifications
 */

export function useListNotificationsV1NotificationsGet<TData = Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError = HTTPValidationError>(
 params?: ListNotificationsV1NotificationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationsV1NotificationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListNotificationsV1NotificationsGetQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update the status of a notification (READ or DISMISSED)

Only the notification owner can update its status.
 * @summary Update Notification Status
 */
export const updateNotificationStatusV1NotificationsNotificationIdPatch = (
    notificationId: string,
    notificationStatusUpdateRequest: NotificationStatusUpdateRequest,
 ) => {
      
      
      return customCatchBackendFetcher<NotificationResponse>(
      {url: `/v1/notifications/${notificationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: notificationStatusUpdateRequest
    },
      );
    }
  


export const getUpdateNotificationStatusV1NotificationsNotificationIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationStatusV1NotificationsNotificationIdPatch>>, TError,{notificationId: string;data: NotificationStatusUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationStatusV1NotificationsNotificationIdPatch>>, TError,{notificationId: string;data: NotificationStatusUpdateRequest}, TContext> => {

const mutationKey = ['updateNotificationStatusV1NotificationsNotificationIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationStatusV1NotificationsNotificationIdPatch>>, {notificationId: string;data: NotificationStatusUpdateRequest}> = (props) => {
          const {notificationId,data} = props ?? {};

          return  updateNotificationStatusV1NotificationsNotificationIdPatch(notificationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationStatusV1NotificationsNotificationIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationStatusV1NotificationsNotificationIdPatch>>>
    export type UpdateNotificationStatusV1NotificationsNotificationIdPatchMutationBody = NotificationStatusUpdateRequest
    export type UpdateNotificationStatusV1NotificationsNotificationIdPatchMutationError = HTTPValidationError

    /**
 * @summary Update Notification Status
 */
export const useUpdateNotificationStatusV1NotificationsNotificationIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationStatusV1NotificationsNotificationIdPatch>>, TError,{notificationId: string;data: NotificationStatusUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationStatusV1NotificationsNotificationIdPatch>>,
        TError,
        {notificationId: string;data: NotificationStatusUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateNotificationStatusV1NotificationsNotificationIdPatchMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    